/**
 * DetailDate component.
 */
import Container from '@components/atoms/container/detailDateContainer';
import Separator from '@components/atoms/text/detailDateSeparator';
import Text from '@components/atoms/text/detailDateText';
import useDetailDate, { SEP } from './useDetailDate';
import { Fragment } from 'react';

/**
 * Displays the event date information.
 */
export default function DetailDate() {
  const date = useDetailDate();
  return (
    <Container id='detailDate'>
      {date.map((item, index) => (
        <Fragment key={`${item.key}-${index}`}>
          <Text bold={item.bold}>{item.text}</Text>
          {index < date.length - 1 ? <Separator>{SEP}</Separator> : null}
        </Fragment>
      ))}
    </Container>
  );
}
